import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { renderCreatableSelect } from '../../common/form/FieldHelper';
import { groupBy, lowerCase } from 'lodash';
import {
  showXeroAccountModal,
  setDataXeroAccountModal,
} from '../integrations/integration_tabs/xero/modal/CreateXeroAccountModalActions';

const defaultTextField = (data) => {
  if (data.code && data.name) {
    return data.code + ' - ' + data.name;
  }

  return data.label;
};

const formatCreateLabel = (defaultAccount) => {
  return (value) => {
    const { code, name } = defaultAccount;
    const account = code ? `${code} - ${name}` : name;
    return `Create in Xero... ${value} or ${account}`;
  };
};

class XeroAccountDropdown extends Component {
  constructor(props) {
    super(props);

    this.onCreateOption = this.onCreateOption.bind(this);
  }

  onCreateOption() {
    const {
      showCreateModal,
      setCreateModalData,
      defaultAccount,
      accountTypes,
      integrationId,
    } = this.props;
    showCreateModal();
    setCreateModalData({ defaultAccount, accountTypes, integrationId });
  }

  getValue() {
    const { listOptions, input, defaultName } = this.props;
    const { value } = input;

    if (value) {
      const valueOption = value
        ? listOptions.find((option) => option.code === value.code)
        : null;

      if (valueOption) {
        return valueOption;
      }
    }

    const defaultValue = defaultName
      ? listOptions.find((l) =>
          lowerCase(l.name).includes(lowerCase(defaultName)),
        )
      : null;

    const defaultValueOption = defaultValue
      ? listOptions.find((option) => option.code === defaultValue.code)
      : null;
    if (defaultValueOption) {
      input.onChange(defaultValueOption);
      return defaultValueOption;
    }

    return null;
  }

  render() {
    const {
      name,
      form,
      displayType,
      textField = defaultTextField,
      defaultAccount,
      defaultValue,
    } = this.props;
    return (
      <div className="field">
        <Field
          {...this.props}
          defaultValue={defaultValue}
          isCreatable={true}
          formId={form}
          component={renderCreatableSelect}
          name={name}
          createOptionPosition="first"
          formatCreateLabel={formatCreateLabel(defaultAccount)}
          getOptionLabel={defaultTextField}
          displayType={displayType}
          textField={textField}
          onCreateOption={this.onCreateOption}
          getValue={this.getValue}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showCreateModal: showXeroAccountModal,
      setCreateModalData: setDataXeroAccountModal,
    },
    dispatch,
  );
}

function mapStateToProps(state, ownProps) {
  const { accounts } = ownProps;
  const groupedData = groupBy(accounts, 'type');
  const groupedListOptions = Object.keys(groupedData).map((groupedKey) => {
    const groupedOption = {
      label: groupedKey,
      options: groupedData[groupedKey],
    };
    return groupedOption;
  });

  return {
    listOptions: accounts,
    groupedListOptions,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(XeroAccountDropdown);
